<template>
    <div class="bg">
        <div class="wrap">
            <div class="info-wrap">
                <span class="title">{{title}}</span>
                <span class="info bold">{{labelTitle}}</span>
                <span class="info">{{labelInfo_1}}</span>
                <span class="info">{{labelInfo_2}}</span>
                <span class="info">{{labelInfo_3}}</span>
                <span class="info">{{labelInfo_4}}</span>
                <span class="sign space">{{organization}}</span>
                <span class="sign">{{date}}</span>
                <span class="submit" @click="infoAgree">{{agree}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {wxAgree} from "@/assets/js/api";

    export default {
        name: '',
        data() {
            return {
                title: "关于开展全国流行病学调研项目-胰岛素抵抗调研项目通知",
                labelTitle: "项目基本信息如下：",
                labelInfo_1: "1、项目名称：全国流行病学调研项目——胰岛素抵抗调研项目",
                labelInfo_2: "2、项目时间：2021年6月-12月",
                labelInfo_3: "3、项目覆盖：全国12个省份",
                labelInfo_4: "4、调研方法：病案收集与分析",
                organization: "中国民族卫生协会",
                date: "2021年5月",
                agree:"同意，下一步",
                docId:this.$store.state.docId
            }
        },
        methods:{
           async infoAgree(){
               let docId = this.docId
                const res = await wxAgree({docId})
                if(res.data.success==true){
                    this.$router.replace({path:"/wx_index"})
                }else {
                    this.$toast(res.data.message)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }
    
    .wrap {
        width: 100%;
        max-width: 400px;
        height: 100vh;
        background: #dedede url("../../assets/img/bg.png") no-repeat;
        background-size: 100% 100%;
    }

    .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 30px;
    }

    .title{
        font-size: 18px;
        font-weight: bold;
        margin: 30px ;
    }

    .info{
        display: flex;
        align-items: start;
        font-size: 15px;
        margin: 5px;
        text-align: left;
        text-indent: 5px;
    }

    .sign{
        display: flex;
        justify-content: flex-end;
        font-size: 18px;
        font-weight: bold;
        margin-right: 20px;
    }

    .space{
        margin-top: 30px;
    }

    .bold{
        font-weight: bold;
        font-size: 16px;
    }

    .submit{
        width: 80%;
        height: 40px;
        line-height: 40px;
        background: #0082C5;
        border-radius: 10px;
        color: #FFF;
        font-size: 20px;
        margin: 50px auto;
    }

</style>
